<template lang="pug">
include SchoolAdminVerification.pug
</template>

<script>
import _ from 'underscore'
import Api from '@/components/services/Api'

export default {
  name: 'SchoolAdminMigration',
  data() {
    let currentHost = `${window.location.protocol}//${window.location.host}/`
    currentHost = currentHost.split("?")[0]

    return {
      token: "",
      hasSuccess: false,
      hasError: false,
      action: Api.getApiUrl() + '/esreps/school-verification/',
      redirectOk: currentHost + 'school-admin/verification-escuela/',
      redirectKo: currentHost + 'school-admin/verification-escuela/',
    }
  },
  created() {
    this.token = this.$store.state.token
    this.action += '?token=' + this.$store.state.token

    const currentHost = `${window.location.protocol}//${window.location.host}/`

    const location = `${window.location}`
    if (location.includes('?success=')) this.hasSuccess = true
    if (location.includes('?error=')) this.hasError = true
  },
}
</script>

<style scoped lang="scss">
@import './../../variables';
@import 'SchoolAdminMigration';
</style>



// WEBPACK FOOTER //
// src/components/school_admin_migration/SchoolAdminVerification.vue